import { t } from '@transifex/native';

export enum GlobalRole {
  WfpGlobalAdmin = 'wfp_global_admin',
  WfpAdmin = 'wfp_admin',
  WfpGlobalViewer = 'wfp_global_viewer',
  WfpViewer = 'wfp_viewer',
  WfpSupport = 'wfp_support'
}

export enum ReportingRole {
  WfpEditor = 'wfp_editor',
  WfpPartnerAdmin = 'wfp_partner_admin',
  WfpApprover = 'wfp_approver',
  WfpVerifier1 = 'wfp_verifier_1',
  WfpVerifier2 = 'wfp_verifier_2',
  PartnerApprover = 'partner_approver',
  PartnerEditor = 'partner_editor',
  PartnerDataCollector = 'partner_data_collector',
  WfpUserExporter = 'wfp_user_exporter'
}

export enum FlaRole {
  WfpFlaAdmin = 'wfp_fla_admin',
  WfpApprover = 'wfp_approver',
  WfpInvoicingFocalPoint = 'wfp_invoicing_focal_point',
  PartnerFlaEditor = 'partner_fla_editor',
  PartnerInvoicingFocalPoint = 'partner_invoicing_focal_point',
  WfpSpotcheckGlobalAdmin = 'wfp_spot_check_global_admin',
  WfpSpotcheckAdmin = 'wfp_spot_check_admin',
  WfpSpotcheckViewer = 'wfp_spot_check_viewer'
}

const GlobalRoleLabel: Record<string, string> = {
  [GlobalRole.WfpGlobalAdmin]: t('WFP global admin'),
  [GlobalRole.WfpAdmin]: t('WFP admin'),
  [GlobalRole.WfpGlobalViewer]: t('WFP global viewer'),
  [GlobalRole.WfpViewer]: t('WFP viewer'),
  [GlobalRole.WfpSupport]: t('WFP support')
};

export const ReportingUserRoleLabel: Record<string, string> = {
  ...GlobalRoleLabel,
  [ReportingRole.WfpEditor]: t('WFP editor'),
  [ReportingRole.WfpPartnerAdmin]: t('WFP partner admin'),
  [ReportingRole.WfpApprover]: t('WFP approver'),
  [ReportingRole.WfpVerifier1]: t('WFP verifier 1'),
  [ReportingRole.WfpVerifier2]: t('WFP verifier 2'),
  [ReportingRole.PartnerApprover]: t('Partner approver'),
  [ReportingRole.PartnerEditor]: t('Partner editor'),
  [ReportingRole.PartnerDataCollector]: t('Partner data collector'),
  [ReportingRole.WfpUserExporter]: t('WFP user exporter')
};

export const FlaUserRoleLabel: Record<string, string> = {
  ...GlobalRoleLabel,
  [FlaRole.WfpFlaAdmin]: t('WFP FLA admin'),
  [FlaRole.WfpApprover]: t('WFP FLA approver'),
  [FlaRole.WfpInvoicingFocalPoint]: t('WFP invoicing focal point'),
  [FlaRole.PartnerFlaEditor]: t('FLA partner editor'),
  [FlaRole.PartnerInvoicingFocalPoint]: t('Partner invoicing focal point'),
  [FlaRole.WfpSpotcheckGlobalAdmin]: t('Global spot-check admin'),
  [FlaRole.WfpSpotcheckAdmin]: t('Spot-check admin'),
  [FlaRole.WfpSpotcheckViewer]: t('Spot-check viewer')
};

export enum FlaSignatoryRole {
  CpSignatory = 'cp_signatory',
  WfpSignatory = 'wfp_signatory',
  Approver = 'approver'
}
export const FlaSignatoryRoleLabel: Record<string, string> = {
  [FlaSignatoryRole.CpSignatory]: t('Cooporating Partner signatory'),
  [FlaSignatoryRole.WfpSignatory]: t('WFP signatory'),
  [FlaSignatoryRole.Approver]: t('Endorser')
};
